import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { SingleTutor } from '../index'
import Logo from '../../../assets/app/logo.png'
import { TutorAvailability, TutorBackground, TutorInformations, TutorPricing, TutorProfileStep } from "./tutor-steps";
import { ProfileRole, ProfileStatusEnum, selectTutorProfile } from "../../../store/profile/profileSlice";
import { getProfile } from "../../../store/profile/profileActions";
import { defaultTutorLanguages, defaultWeekDays } from "./tutor-defaults";
import { StepIndicator } from "./step-indicator";

const TUTOR_CREATE_STEPS = [
    { id: 2, label: "Informations" },
    { id: 3, label: "Profile" },
    { id: 4, label: "Background" },
    { id: 5, label: "Availability" },
    { id: 6, label: "Pricing" },
];

const TutorForm = ({ currentStep, setCurrentStep }) => {
    const { user } = useSelector((state) => state.auth);
    const tutorProfile = useSelector(selectTutorProfile);
    const [activeTab, setActiveTab] = useState(0);
    const dispatch = useDispatch();
    const initialValues = {
        firstName: user.firstName,
        lastName: user.lastName,
        userId: user._id,
        avatar: user.avatar,
        avatarId: "",
        country: user.country,
        speak: defaultTutorLanguages.speak,
        teach: defaultTutorLanguages.teach,
        tutorId: "",
        education: [],
        experience: [],
        certificates: [],
        days: defaultWeekDays,
        prices: [],
    }

    const methods = useForm({
        defaultValues: initialValues
    })

    useEffect(() => {
        dispatch(getProfile({role: ProfileRole.TUTOR}))
        .unwrap()
        .then((data) => {
            if(data){
                const { experience, certificate, education, speak, teach, ...rest } = data;
                if(data.status === ProfileStatusEnum.waitForApproval){
                    setCurrentStep(10);
                    return;
                }
                methods.reset({
                    ...methods.getValues(),
                    ...rest,
                    speak: speak?.length ? speak : defaultTutorLanguages.speak,
                    teach: teach?.length ? teach : defaultTutorLanguages.teach,
                    days: methods.getValues("days")?.length ? methods.getValues("days") : defaultWeekDays,
                    education: [],
                    experience: [],
                    certificates: [],
                });
            }
        })
    }, [])



    const data = methods.watch();
    const getProfileData = () => {
        if (tutorProfile?.education?.length || tutorProfile?.experience?.length || tutorProfile?.certificate?.length) {
            return {...data, 
                education: [...(data.education || []), ...(tutorProfile.education || [])],
                experience: [...(data.experience || []), ...(tutorProfile.experience || [])],
                certificates: [...(data.certificates || []), ...(tutorProfile.certificate || [])],

            }
        }
        return data;
    }

    return (

        <FormProvider {...methods}>

            <div className='w-full relative'>
                <img className='m-auto my-10' src={Logo} alt="Logo" />
                <StepIndicator steps={TUTOR_CREATE_STEPS} currentStep={currentStep} />
                <div className="max-w-[600px] mx-auto">
                    {currentStep === 2 && <TutorInformations setActiveTab={setActiveTab} currentStep={currentStep} setCurrentStep={setCurrentStep} />}
                    {currentStep === 3 && <TutorProfileStep setActiveTab={setActiveTab} setCurrentStep={setCurrentStep} />}
                    {currentStep === 4 && <TutorBackground setActiveTab={setActiveTab} setCurrentStep={setCurrentStep} />}
                    {currentStep === 5 && <TutorAvailability setActiveTab={setActiveTab} setCurrentStep={setCurrentStep} />}
                    {currentStep === 6 && <TutorPricing setActiveTab={setActiveTab} setCurrentStep={setCurrentStep} />}
                </div>
            </div>
            <div className="hidden xl:block w-1/2 bg-nt-grey-light h-screen fixed top-0 right-0 p-[20px] overflow-auto text-nt-blue">
                <SingleTutor profile={getProfileData()} activeTab={activeTab} setActiveTab={setActiveTab} />
            </div>
        </FormProvider>
    );
}

export { TutorForm }
